import {
  radioUI,
  radioSchema,
} from 'platform/forms-system/src/js/web-component-patterns';
import content from '../../../../utils/content.json';

const marriageTypeOptions = {
  ceremonial: {
    label: 'Ceremonial',
    description: '',
  },
  'common-law': {
    label: 'Common-law',
    description: '',
  },
  proxy: {
    label: 'Proxy',
    description:
      'This isn’t common. It means another person acted on behalf of you or your partner for the ceremony.',
  },
  tribal: {
    label: 'Tribal',
    description: '',
  },
};

const getRadioOptionFields = field =>
  Object.entries(marriageTypeOptions).reduce(
    (acc, [key, value]) => ({ ...acc, [key]: value[field] }),
    {},
  );

/** @type {PageSchema} */
export default {
  uiSchema: {
    marriageType: radioUI({
      title: content['household-veteran-marriage-info-title'],
      labels: getRadioOptionFields('label'),
      descriptions: getRadioOptionFields('description'),
      tile: true,
      labelHeaderLevel: 3,
    }),
  },
  schema: {
    type: 'object',
    required: ['marriageType'],
    properties: {
      marriageType: radioSchema(Object.keys(marriageTypeOptions)),
    },
  },
};
